import React from "react";

/**
 * Circular engineer avatar — renders the uploaded profilePhoto when set,
 * otherwise falls back to a coloured initials chip. Used in the admin table,
 * appointment picker, appointment cards, and project detail. Keeping this in
 * one place means photo/colour consistency is impossible to break.
 */
export function EngineerAvatar({ eng, size = 36, className = "" }) {
    const src = React.useMemo(() => {
        const p = eng?.profilePhoto || "";
        if (!p) return "";
        if (p.startsWith("http") || p.startsWith("data:")) return p;
        return `${process.env.REACT_APP_BACKEND_URL}${p}`;
    }, [eng?.profilePhoto]);

    const initials = eng?.initials || (
        `${(eng?.firstName || "")[0] || "?"}${(eng?.lastName || "")[0] || ""}`
    ).toUpperCase();

    return (
        <span
            className={`inline-flex items-center justify-center rounded-full text-white font-medium overflow-hidden shrink-0 ${className}`}
            style={{
                width: size,
                height: size,
                fontSize: Math.max(10, Math.floor(size / 3)),
                background: eng?.colour || "#3E9E2E",
            }}
            aria-label={eng?.displayName || "Engineer"}
            data-testid={`engineer-avatar-${eng?.id || "unknown"}`}
        >
            {src ? <img src={src} alt="" className="w-full h-full object-cover" /> : initials}
        </span>
    );
}
